import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ITEM_PER_PAGE, PUBLIC_URL, SEARCH_DELAY } from "../../app.config";
import Pagination from "../../component/Pagination";
import SearchAndExport from "../../component/SearchAndExport";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import useDebounce from "../hooks/useDebounce";
import * as API from "../../utils/api.service";
import {
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleNoDataFound,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
} from "../../utils/common.service";
import {
  getCategoryListApiCall,
  editCategoryDataApiCall,
} from "../../Store/slices/categorySlice";

export default function ManageCategory() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
  const [page, setPage] = useState(1);
  const [fieldSort, setFieldSort] = useState("id desc");
  const [ascSort, setAscSort] = useState(false);
  const [sortColumn, setSortColumn] = useState("id");
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSortChange = (fieldName, sort) => {
    if (sort === "asc") {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(true);
    } else {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(false);
    }
  };

  const {
    categoryList: { data: categoryList },
  } = useSelector((state) => state.category);

  useEffect(() => {
    handleCompanyListAPI();
  }, [page, debounce, fieldSort]);

  const handleCompanyListAPI = () => {
    let submitData = {
      search: debounce,
      page: page,
      fieldSort,
    };
    let request = {};
    dispatch(getCategoryListApiCall(request));
  };

  const handleStatusChange = (id, changeChecked) => {
    dispatch(setLoader(true));
    let submitData = {
      client_id: id,
      is_active: changeChecked,
    };
    dispatch(editCategoryDataApiCall(submitData));
    dispatch(setLoader(false));
  };

  const handleDeleteManage = async (id) => {
    SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
      if (result?.isConfirmed) {
        dispatch(setLoader(true));
        let submitData = {
          id: id,
          status: "Inactive",
        };

        // console.log("444444444444444444444444444444444444444444444444444444",submitData);
        

        await dispatch(editCategoryDataApiCall(submitData));
        await handleCompanyListAPI();
        await SWIT_DELETE_SUCCESS(`Category delete successfully`);
      }
    });
  };

  //   const handleDeleteManage = async (id) => {
  //     SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
  //       if (result?.isConfirmed) {
  //         dispatch(setLoader(true));
  //         let submitData = {
  //           id: id,
  //           status:"Inactive",
  //         };

  //         await dispatch(editClientDataApiCall(submitData));
  //         await handleCompanyListAPI();
  //         await SWIT_DELETE_SUCCESS(`Client delete successfully`);
  //       }
  //     });
  //   };

  // const handleExportApiCall = async (type) => {
  //   dispatch(setLoader(true));
  //   let submitData = {
  //     search: debounce,
  //     fieldSort,
  //   };
  //   const { code, data } = await API.getClientExportListApi(submitData);
  //   if (code === "1") {
  //     if (type === "PDF") {
  //       ExportToPdf(data, "clientList", "Client List");
  //     } else if (type === "CSV") {
  //       ExportToCSV(data, "clientList");
  //     } else if (type === "EXCEL") {
  //       ExportToExcel(data, "clientList");
  //     }
  //   }
  //   dispatch(setLoader(false));
  // };

  // console.log("*****************************************",clientList);
  const companyListData = useMemo(() => {
    return categoryList?.map((item, index) => (
      <tr key={index}>
        <td>{item?.name}</td>
        <td>{item?.status}</td>
        <td>
          <a
            className="text-reset fs-18 cursor_pointer"
            onClick={() =>
              navigate(`/manage_category/view_category_details`, {
                state: { clientData: item },
              })
            }
          >
            <i className="ri-eye-line"></i>
          </a>
          <a
            className="text-reset fs-18 m-1 cursor_pointer"
            onClick={() =>
              navigate(`/manage_category/edit_category`, {
                state: { clientData: item },
              })
            }
          >
            <i className="ri-edit-line"></i>
          </a>
          <a
            className="text-reset fs-18 cursor_pointer"
            onClick={() => handleDeleteManage(item?.id)}
          >
            <i className="ri-delete-bin-6-line"></i>
          </a>
        </td>
      </tr>
    ));
  }, [categoryList]);
  
  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Manage Category`} header={`Category`} />
          <div className="col-sm-6">
            <div className="d-flex justify-content-end">
              <div className="gap-2">
                <button
                  type="button"
                  className="btn btn-soft-primary"
                  onClick={() => navigate(`/manage_category/add_category`)}
                >
                  <i className="ri-settings-2-line align-text-bottom me-1 fs-16 lh-1"></i>
                  Add Category
                </button>
              </div>
            </div>
          </div>
          <div className="card rounded-3">
            <div className="card-body">
              <div className="responsive-table-plugin">
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive"
                    data-pattern="priority-columns"
                  >
                    {Object.keys(categoryList)?.length > 0 ? (
                      <>
                        <table
                          id="tech-companies-1"
                          className="table table-centered mb-0 table-hover"
                        >
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{companyListData}</tbody>
                        </table>
                      </>
                    ) : (
                      <>{handleNoDataFound("Category")}</>
                    )}
                  </div>
                  {/* <Pagination
                    per_page={ITEM_PER_PAGE}
                    pageCount={categoryList?.total_client}
                    onPageChange={handlePageChange}
                    page={page}
                    lableName={`Category`}
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  
}
